import script from "./CostBreakdownView.vue?vue&type=script&setup=true&lang=js"
export * from "./CostBreakdownView.vue?vue&type=script&setup=true&lang=js"

import "./CostBreakdownView.vue?vue&type=style&index=0&id=7ce5b8fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce5b8fd"]])

export default __exports__